import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { findRouteForPathname } from './useRoutePermission';

const APP_NAME = 'Ministry Data Portal';

const PUBLIC_PREFIX_TITLES = [
  { prefix: '/sign-in', title: 'Sign in' },
  { prefix: '/sign-up', title: 'Sign up' },
];

const PUBLIC_PATH_TITLES = {
  '/how-to': 'How to Get Started',
  '/faqs': 'FAQs',
  '/accessibility': 'Accessibility Statement',
};

/**
 * Sets document.title per route for WCAG 2.4.2 (unique page titles in SPA).
 */
export function useDocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    for (const { prefix, title } of PUBLIC_PREFIX_TITLES) {
      if (pathname === prefix || pathname.startsWith(`${prefix}/`)) {
        document.title = `${title} — ${APP_NAME}`;
        return;
      }
    }
    if (PUBLIC_PATH_TITLES[pathname]) {
      document.title = `${PUBLIC_PATH_TITLES[pathname]} — ${APP_NAME}`;
      return;
    }
    const route = findRouteForPathname(pathname);
    if (route) {
      document.title = `${route.label} — ${APP_NAME}`;
      return;
    }
    document.title = APP_NAME;
  }, [pathname]);
}
